// Libraries
import { action, computed, observable } from "mobx";
import moment, { Moment } from "moment";
import "moment-timezone";

// Core
import { ModelBase } from "Core/Models/ModelBase";
import { isEmptyOrWhitespace } from "Core/Utils/Utils";

export class InspectionStageModel extends ModelBase<InspectionStageModel, InspectionStageModelDTO> {
    // #region Properties

    @observable
    inspectionStageId = "";

    @observable
    inspectionStageName = "";

    @observable
    inspectionStageColor = "";

    @observable
    inspectionStageType = 0;

    @observable
    propertyInspectionStageDate: Moment | null = null;

    @observable
    inspectionStageStatusName = "";

    @observable
    inspectionStageStatusType = 0;

    // #endregion Properties

    @computed
    public get inspectionStageDateFormatted() {
        return this.propertyInspectionStageDate !== null && this.propertyInspectionStageDate !== undefined ? this.propertyInspectionStageDate.format("DD/MM/YYYY") : "";
    }

    @action
    public fromDto = (dto: InspectionStageModelDTO): void => {
        this.inspectionStageId = dto.inspectionStageId;
        this.inspectionStageName = dto.inspectionStageName;
        this.inspectionStageColor = dto.inspectionStageColor;
        this.inspectionStageType = dto.inspectionStageType;
        this.propertyInspectionStageDate = !isEmptyOrWhitespace(dto.propertyInspectionStageDate) ? moment.tz(dto.propertyInspectionStageDate, "Europe/London") : null;
        this.inspectionStageStatusName = dto.inspectionStageStatusName;
        this.inspectionStageStatusType = dto.inspectionStageStatusType;
    };

    public toDto = (): InspectionStageModelDTO => {
        throw "toDto is not supported";
    };
}

export interface InspectionStageModelDTO {
    inspectionStageId: string;
    inspectionStageName: string;
    inspectionStageColor: string;
    inspectionStageType: number;
    propertyInspectionStageDate: string;
    inspectionStageStatusName: string;
    inspectionStageStatusType: number;
}
